import { Global, ThemeProvider } from '@emotion/react';
import type { ReactNode } from 'react';
import type { Theme } from '..';
import { theme as baseTheme } from '..';
import { baseStyle } from './baseStyle';

export const SdsThemeProvider = ({ children, theme }: { children: ReactNode; theme?: Theme }) => {
  return (
    <ThemeProvider theme={theme || baseTheme}>
      <Global styles={baseStyle} />
      {children}
    </ThemeProvider>
  );
};
